<template>
  <transition name="modal">
    <div class="modal-mask" @click="closeModal">
      <div class="modal-wrapper">
        <div class="modal-container" :style="containerStyle">
          <slot></slot>
          <dialogLoading v-if="isDialogLoading"></dialogLoading>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import dialogLoading from './loading'

export default {
  components: {
    dialogLoading
  },
  props: {
    width: {
      type: String,
      default: () => '400px'
    },
    height: {
      type: String,
      default: () => 'auto'
    },
    customStyles: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters([
      'isDialogLoading'
    ]),
    containerStyle () {
      return { ...this.customStyles, height: this.height, width: this.width }
    }
  },
  methods: {
    closeModal (e) {
      if (!['modal-mask', 'modal-wrapper'].includes(e.target.className)) {
        return
      }
      this.$emit('hide')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  .modal-mask
    position: fixed
    height: 100vh
    overflow: auto
    z-index: 9998
    top: 0
    left: 0
    width: 100%
    min-height: 100%
    background-color: rgba(0, 0, 0, .5)
    transition: opacity .3s ease
  .modal-wrapper
    width: 100%
    vertical-align: middle
  .modal-container
    position: relative
    max-width: 95%
    margin: 80px auto
    padding: 10px
    background-color: white
    border-radius: 5px
    box-shadow: 0 2px 8px rgba(0, 0, 0, .1)
    box-sizing: border-box
    transition: all .3s ease
    @media screen and (max-width: 1070.9px)
      margin: 15% auto
  .modal-enter
    opacity: 0
  .modal-leave-active
    opacity: 0
  .modal-enter .modal-container,
  .modal-leave-active .modal-container
    -webkit-transform: scale(1.1)
    transform: scale(1.1)
    @media screen and (max-width: 1070.9px)
      -webkit-transform: scale(0.9)
      transform: scale(0.9)
</style>



// WEBPACK FOOTER //
// src/components/dialog/container.vue